import { PrismicRichText } from '@prismicio/react'
import BackgroundImage from 'gatsby-background-image'
import { convertToBgImage } from 'gbimage-bridge'
import React, { memo } from 'react'

const Privacy = ({
  pageTitle,
  corporationTitle,
  backgroundImage,
  updatedTitle,
  updatedDate,
  policy,
  historyTitle,
  history,
}) => {
  const bgImage = convertToBgImage(backgroundImage.gatsbyImageData)

  return (
    <section className="privacy-section">
      <BackgroundImage Tag="div" className="background-image" {...bgImage}>
        <div className="container">
          <div className="privacy-header">
            <h1 className="title">{pageTitle}</h1>
            <p className="p p-26 corporation">{corporationTitle}</p>
            <p className="p p-14 update">
              {updatedTitle} {updatedDate}
            </p>
          </div>
        </div>
      </BackgroundImage>

      <div className="container">
        <div className="privacy-box">
          <PrismicRichText field={policy} />
        </div>
        <div className="history">
          <p>{historyTitle}</p>
          <ul className="history-list">
            {history.map((history) => (
              <li key={history} className="history-item">
                {history.history_date.text}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default memo(Privacy)
